/**
 * Bunny AI Gateway
 * Security-first AI gateway. One API. Every model. Total protection. All `/v1/_*` endpoints are transparently proxied to the underlying AI Gateway runtime. Use a valid API key in the `Authorization` header.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Content } from './content';

export interface ChatMessage {
  role: ChatMessage.RoleEnum;
  content: Content;
}
export namespace ChatMessage {
  export type RoleEnum = 'system' | 'user' | 'assistant' | 'tool' | 'developer' | 'function';
  export const RoleEnum = {
    system: 'system' as RoleEnum,
    user: 'user' as RoleEnum,
    assistant: 'assistant' as RoleEnum,
    tool: 'tool' as RoleEnum,
    developer: 'developer' as RoleEnum,
    function: 'function' as RoleEnum,
  };
}
